import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import HomeIcon from "@mui/icons-material/Home";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import FeaturedPlayListIcon from "@mui/icons-material/FeaturedPlayList";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import MenuBottom from "./MenuBottom";
import { Link } from "react-router-dom";
import { RxHamburgerMenu } from "react-icons/rx";
import { useState } from "react";
import axios from "axios";
import { LoginContext } from "../../lib/context";

const Layout = ({ children }) => {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [modal, setModal] = useState(false);
  const [loginModal, setLoginModal] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [returnedData, setReturnedData] = useState("none");

  const { login, setLogin } = React.useContext(LoginContext);

  console.log(login);

  const validateEmail = (email) => {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(String(email).toLowerCase())) {
      return true;
    } else {
      return false;
    }
  };

  const handleRegister = (e) => {
    e.preventDefault();
    if (
      email.length === 0 ||
      password.length === 0 ||
      confirmPassword.length === 0
    ) {
      if (email.length === 0) {
        setEmailError(true);
      }
      if (password.length === 0) {
        setPasswordError(true);
      }
      if (confirmPassword.length === 0) {
        setConfirmPasswordError(true);
      }
    } else if (validateEmail(email) === false) {
      setEmailError(true);
    } else if (password !== confirmPassword) {
      setConfirmPasswordError(true);
    } else {
      const formData = {
        name: "User",
        email: email,
        password: password,
        password_confirmation: confirmPassword,
      };

      axios({
        url: "https://phpstack-896782-4100562.cloudwaysapps.com/api/register",
        method: "POST",
        data: formData,
      })
        .then((data) => {
          setReturnedData(data);
          console.log(data);
          window.location.reload(false);
        })
        .catch((error) => {
          setReturnedData(error);
          console.log(error);
        });

      setEmail("");
      setPassword("");
      setConfirmPassword("");
    }
  };

  const handleLogin = (e) => {
    e.preventDefault();

    if (email.length === 0 || password.length === 0) {
      if (email.length === 0) {
        setEmailError(true);
      }
      if (password.length === 0) {
        setPasswordError(true);
      }
    } else if (validateEmail(email) === false) {
      setEmailError(true);
    } else {
      const formData = {
        email: email,
        password: password,
      };

      axios({
        url: "https://phpstack-896782-4100562.cloudwaysapps.com/api/login",
        method: "POST",
        data: formData,
      })
        .then((response) => {
          const data = response.data;
          setLogin(data.token);
          console.log(login);
        })
        .catch((error) => {
          console.log("Error", error);
          setEmailError(true);
          setPasswordError(true);
        });

      setEmail("");
      setPassword("");
      setConfirmPassword("");
    }
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        zIndex: "999",
        ...(open && { background: "#0000003b !important" }),
      }}
    >
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar>
          <AppBarFlex>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{ mr: 2 }}
              className="w-auto h-auto"
            >
              <RxHamburgerMenu className="w-7 h-auto" />
            </IconButton>
            <Box sx={{ textAlign: "center" }}>
              <Typography>pokeprice.io</Typography>
              <Typography component={"strong"} variant="fontSize16">
                Home
              </Typography>
            </Box>
            <AppBarSign>
              <Box>
                <button onClick={() => setModal(true)}>
                  <Typography
                    variant="fontSize10"
                    sx={{
                      backgroundColor: "white",
                      color: (theme) => theme.palette.red.main,
                      borderRadius: "12px",
                      padding: "2px 4px",
                    }}
                  >
                    SIGN UP
                  </Typography>
                </button>

                {modal && (
                  <div
                    className="fixed z-10 inset-0 overflow-y-auto"
                    aria-labelledby="modal-title"
                    role="dialog"
                    aria-modal="true"
                  >
                    <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                      <div
                        className="fixed inset-0 cursor-pointer bg-gray-500 bg-opacity-75 transition-opacity"
                        aria-hidden="true"
                        onClick={() => setModal(false)}
                      ></div>
                      <span
                        className="hidden sm:inline-block sm:align-middle sm:h-screen"
                        aria-hidden="true"
                      >
                        ​
                      </span>

                      <form
                        onSubmit={handleRegister}
                        className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
                      >
                        <div className="flex flex-col items-center justify-start py-6">
                          <h2 className="mb-5 text-2xl font-extrabold text-gray-700">
                            Sign Up
                          </h2>
                          <p className="mb-5 text-sm text font-extrabold text-black">
                            Already signed up?{" "}
                            <button
                              className="underline text-pinkColor"
                              onClick={() => {
                                setModal(false);
                                setLoginModal(true);
                              }}
                            >
                              Log in
                            </button>
                          </p>
                          <button className="flex items-center font-bold w-11/12 justify-center px-4 py-2 mb-5 text-white bg-blue-500 rounded-xl">
                            <i className="mr-2 fas fa-facebook-square"></i>{" "}
                            Login
                          </button>
                          <input
                            className="px-4 text-black py-1 mb-5 w-11/12 rounded-xl bg-white border border-gray-300"
                            type="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                          {emailError && (
                            <p className="text-red-700 -mt-3 font-bold text-sm">
                              Please enter a valid email address
                            </p>
                          )}
                          <input
                            className="px-4 text-black py-1 mb-5 w-11/12 rounded-xl bg-white border border-gray-300"
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                          {passwordError && (
                            <p className="text-red-700 -mt-3 font-bold text-sm">
                              Please enter a valid password
                            </p>
                          )}
                          <input
                            className="px-4 text-black py-1 mb-5 w-11/12 rounded-xl bg-white border border-gray-300"
                            type="password"
                            placeholder="Confirm Password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                          />
                          {confirmPasswordError && (
                            <p className="text-red-700 -mt-3 font-bold text-sm">
                              Please enter a valid password
                            </p>
                          )}
                          <p className="mb-5 text-sm w-11/12 text-gray-500">
                            We will regularly send you emails with offers
                            regarding our services. You can unsubscribe from
                            receiving these marketing emails at any time, free
                            of charge, via the link in the emails.
                          </p>
                          <p className="mb-5 text-sm w-11/12 text-gray-500">
                            By selecting Register or Social login you agree
                            you've read and accepted ourUser Agreement. Please
                            see ourPrivacy Policyfor information regarding the
                            processing of your data.
                          </p>
                          <button
                            type="submit"
                            className="px-4 py-2 text-white bg-pinkColor rounded"
                          >
                            REGISTER
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                )}
                {loginModal && (
                  <div
                    className="fixed flex justify-center items-center z-10 inset-0 overflow-y-auto"
                    aria-labelledby="modal-title"
                    role="dialog"
                    aria-modal="true"
                  >
                    <div className="w-80 flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                      <div
                        className="fixed inset-0 cursor-pointer bg-gray-500 bg-opacity-75 transition-opacity"
                        aria-hidden="true"
                        onClick={() => setLoginModal(false)}
                      ></div>
                      <span
                        className="hidden sm:inline-block sm:align-middle sm:h-screen"
                        aria-hidden="true"
                      >
                        ​
                      </span>

                      <form
                        onSubmit={handleLogin}
                        className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
                      >
                        <div className="flex flex-col items-center justify-start py-6">
                          <h2 className="mb-5 text-2xl font-extrabold text-gray-700">
                            Sign In
                          </h2>
                          <p className="mb-5 text-sm text font-extrabold text-black">
                            New here?{" "}
                            <button
                              onClick={() => {
                                setLoginModal(false);
                                setModal(true);
                              }}
                              className="underline text-pinkColor"
                            >
                              Sign up
                            </button>
                          </p>
                          <button className="flex items-center font-bold w-11/12 justify-center px-4 py-2 mb-5 text-white bg-blue-500 rounded-xl">
                            <i className="mr-2 fas fa-facebook-square"></i>{" "}
                            Login
                          </button>
                          <input
                            className="px-4 text-black py-1 mb-5 w-11/12 rounded-xl bg-white border border-gray-300"
                            type="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                          {emailError && (
                            <p className="text-red-700 -mt-3 font-bold text-sm">
                              Please enter a valid email address
                            </p>
                          )}
                          <input
                            className="px-4 text-black py-1 mb-5 w-11/12 rounded-xl bg-white border border-gray-300"
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                          {passwordError && (
                            <p className="text-red-700 -mt-3 font-bold text-sm">
                              Please enter a valid password
                            </p>
                          )}
                          <button
                            type="submit"
                            className="px-4 py-2 w-11/12 text-white bg-pinkColor rounded-xl"
                          >
                            Sign In
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                )}
                <Box
                  sx={{
                    backgroundColor: (theme) => theme.palette.redBold.main,
                    borderRadius: "12px",
                    width: "27px",
                    height: "14px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft: "23px",
                  }}
                >
                  <Typography variant="fontSize10">0%</Typography>
                </Box>
              </Box>
              <SignIcon>
                <button>
                  <AccountCircleIcon />
                </button>
              </SignIcon>
            </AppBarSign>
          </AppBarFlex>
        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            borderRight: "0px",
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />

        <List>
          {menuList.map((item, index) => (
            <ListItem key={item.name} disablePadding>
              <ListItemButton>
                <ListItemIcon sx={{ minWidth: "40px" }}>
                  {item.Icon}
                </ListItemIcon>
                <Link to={`/${item.to}`}>
                  <ListItemTextSpan primary={item.name} />
                </Link>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
      <Main open={open}>
        <DrawerHeader sx={{ background: "none" }} />
        {children}
      </Main>

      <MenuBottom open={open} />
    </Box>
  );
};

const menuList = [
  { name: "Home", Icon: <HomeIcon />, to: "" },
  {
    name: "User Profile",
    Icon: <AccountCircleIcon />,
    to: "userprofile/:userId",
  },
  { name: "Chat With Us", Icon: <ChatBubbleIcon />, to: "" },
  {
    name: "Change Currency",
    Icon: <CurrencyExchangeIcon />,
    to: "currencypreference",
  },
  { name: "Privacy Policy", Icon: <VerifiedUserIcon />, to: "privacypolicy" },
  {
    name: "Terms and Conditions",
    Icon: <FeaturedPlayListIcon />,
    to: "termsandconditions",
  },
  { name: "Data Deletion", Icon: <RequestPageIcon />, to: "datadeletion" },
];

const drawerWidth = 240;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    height: "auto",
    width: "100%",
    // padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      // background:'rgb(60, 60, 60)',
      zIndex: -2,
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "&.MuiPaper-root": {
    backgroundColor: "rgba(242,59,47,1.00)",
    boxShadow: "none",
  },
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    backgroundColor: theme.palette.red.main,
    "& .MuiPaper-root": {
      background: "#0000003b !important",
    },
    "&.MuiPaper-root": {
      boxShadow: "none",
      backgroundColor: theme.palette.red.main,
      borderRight: "none",
      zIndex: -1,
      "& .MuiDrawer-paper": {
        borderRight: "none",
      },
    },
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  background: "red",
  justifyContent: "flex-start",
  boxShadow: "none",
  "& svg": {
    color: "white",
    fontSize: "40px",
  },
}));

const ListItemTextSpan = styled(ListItemText)({
  "& span": {
    fontSize: "16px",
    fontWeight: 700,
  },
});

const AppBarFlex = styled(Box)({
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  alignItems: "center",
});

const AppBarSign = styled(Box)({
  display: "flex",
});

const SignIcon = styled(Box)({
  display: "flex",
  alignItems: "center",
  "& svg": {
    fontSize: "33px",
  },
});
export default Layout;
